import { createFileRoute } from '@tanstack/react-router'
import { ContactPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/contact')({
  head: () => staticRouteHead('contact', 'en'),
  component: ContactPage,
})
